export const operandPattern = /^0$|^-?[0-9]\d*(\.\d+)?$/;
